<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'shared.modals.user-delete.title' | translate }}
    </h5>
  </div>
  <div class="modal-body">
    {{ 'shared.modals.user-delete.description' | translate:{userName: userName} }}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onCloseModal()">
      {{ 'shared.modals.user-delete.form.buttons.close' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="onDeleteUser()">
      {{ 'shared.modals.user-delete.form.buttons.delete' | translate }}
    </button>
  </div>
</div>
